import { Injectable } from '@angular/core';
import { DatePipe } from '@angular/common';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { JhiDateUtils } from 'ng-jhipster';

import { Converter, createRequestOption } from '../shared';
import { Queue, Registration, ResponseWrapper, QueueCreateRequest } from '../models';
import { BaseService } from './base-service';

@Injectable()
export class QueueService implements BaseService<Queue> {

    private resourceUrl = 'api/queues';
    private publicResourceUrl = 'api/public/queues';

    constructor(private http: Http,
                private datePipe: DatePipe,
                private dateUtils: JhiDateUtils) {
    }

    create(queue: QueueCreateRequest): Observable<Queue> {
        const copy = Converter.toJson(queue);
        return this.http.post(this.resourceUrl, copy).map((response: Response) => {
            return Converter.fromJson(Queue, response.json());
        });
    }

    update(queue: Queue): Observable<Queue> {
        const copy = Converter.toJson(queue);
        return this.http.put(this.resourceUrl, copy).map((response: Response) => {
            return Converter.fromJson(Queue, response.json());
        });
    }

    find(id: number): Observable<Queue> {
        return this.http.get(`${this.resourceUrl}/${id}`).map((response: Response) => {
            return Converter.fromJson(Queue, response.json());
        });
    }

    all(): Observable<Array<Queue>> {
        return this.http.get(this.resourceUrl).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }

    query(request?: any): Observable<ResponseWrapper> {
        const options = createRequestOption(request);
        return this.http.get(this.resourceUrl, options).map((response: Response) => {
            const result = Converter.fromJsonArray(Queue, response.json());
            return Converter.toResponseWrapper(result, response);
        });
    }

    delete(id: number): Observable<Response> {
        return this.http.delete(`${this.resourceUrl}/${id}`);
    }

    findChildrenPublic(id: number): Observable<Array<Queue>> {
        return this.http.get(`${this.publicResourceUrl}/${id}/children`).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }

    findChildren(id: number): Observable<Array<Queue>> {
        return this.http.get(`${this.resourceUrl}/${id}/children`).map((response: Response) => {
            return Converter.fromJsonArray(Queue, response.json());
        });
    }

    findPendingRegistrations(queueId: number, date: Date): Observable<Array<Registration>> {
        const dateString = this.datePipe.transform(date, 'yyyy-MM-dd');
        return this.http.get(`${this.publicResourceUrl}/${queueId}/registrations/${dateString}`)
            .map((response: Response) => {
                return Converter.fromJsonArray(Registration, response.json(), this.dateUtils);
            });
    }

    findNormalPendingRegistrations(queueId: number): Observable<Array<Registration>> {
        return this.http.get(`${this.publicResourceUrl}/${queueId}/registrations/normal`)
            .map((response: Response) => {
                return Converter.fromJsonArray(Registration, response.json(), this.dateUtils);
            });
    }

    findPlannedPendingRegistrations(queueId: number): Observable<Array<Registration>> {
        return this.http.get(`${this.publicResourceUrl}/${queueId}/registrations/planned`)
            .map((response: Response) => {
                return Converter.fromJsonArray(Registration, response.json(), this.dateUtils);
            });
    }

    findProcessingRegistrations(queueId: number): Observable<Array<Registration>> {
        return this.http.get(`${this.publicResourceUrl}/${queueId}/registrations/processing`)
            .map((response: Response) => {
                return Converter.fromJsonArray(Registration, response.json(), this.dateUtils);
            });
    }

    startProcessing(id: number): Observable<Response> {
        return this.http.post(`${this.resourceUrl}/${id}/start-processing`, null);
    }

    stopProcessing(id: number): Observable<Response> {
        return this.http.post(`${this.resourceUrl}/${id}/stop-processing`, null);
    }

    startBreak(id: number, minutesLeft: number): Observable<Response> {
        return this.http.post(`${this.resourceUrl}/${id}/start-break`, { 'minutesLeft': minutesLeft });
    }

    startRegistration(id: number): Observable<Response> {
        return this.http.post(`${this.resourceUrl}/${id}/start-registration`, null);
    }

    stopRegistration(id: number): Observable<Response> {
        return this.http.post(`${this.resourceUrl}/${id}/stop-registration`, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/queue.service.ts